import React from "react";
import { DatePicker } from "@blueprintjs/datetime";
import { useHistory } from "react-router-dom";
import { ToolbarGroup } from "../Toolbar";
import {
  Breadcrumb,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Intent,
  Menu,
  MenuItem,
  Popover,
  Classes
} from "@blueprintjs/core";
import Icon from "../../atoms/Icon/Icon";
import { PopoverInteractionKind } from "@blueprintjs/core";

import classNames from "classnames";
import styles from "./OpportunityDetails.module.scss";

function OpportunityDetailsHeader({
  opportunity,
  onVisibilityChange,
  onExpirationChange,
  onExpirationExtended,
  onDiscontinue,
  isReadOnly
}) {
  const name =
    opportunity && opportunity.product ? opportunity.product.name : "";
  const history = useHistory();

  const numberOfDaysFromTwentyYearsFromNow = 365 * 20;
  const twentyYearsFromNow = new Date();
  twentyYearsFromNow.setDate(
    twentyYearsFromNow.getDate() + numberOfDaysFromTwentyYearsFromNow
  );

  const minDate = opportunity.expiresAt
    ? new Date(opportunity.expiresAt)
    : new Date();

  const BREADCRUMBS = [
    {
      text: "Opportunities",
      onClick: () => history.push("/opportunities")
    },
    {
      text: name
    }
  ];

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.upperWrapper}>
        <div className={styles.headerWrapper}>
          <h2>Opportunities</h2>
        </div>
        <ToolbarGroup>
          <ButtonGroup>
            <Popover>
              <Button
                icon={<Icon name="wrench" size={11} color="#00998c" />}
                className="narrow bold"
                text="Actions"
                disabled={isReadOnly}
              />
              { !isReadOnly && (
              <Menu>
                <MenuItem
                  text="Extend Expiration Date"
                  popoverProps={{
                    interactionKind: PopoverInteractionKind.CLICK
                  }}
                >
                  <DatePicker
                    defaultValue={minDate}
                    minDate={minDate}
                    maxDate={twentyYearsFromNow}
                    onChange={onExpirationChange}
                  />
                  <Button
                    className={classNames(
                      styles.extendOpportunityButton,
                      Classes.POPOVER_DISMISS
                    )}
                    intent={Intent.PRIMARY}
                    text="Apply"
                    onClick={onExpirationExtended}
                    disabled={isReadOnly}
                  />
                </MenuItem>
                <MenuItem
                  className="narrow bold"
                  text="Opportunity Visibility"
                  popoverProps={{
                    interactionKind: PopoverInteractionKind.CLICK
                  }}
                >
                  <MenuItem
                    className={
                      opportunity && opportunity.visibility === "Public"
                        ? styles.selectedMenuItem
                        : null
                    }
                    text="Public"
                    labelElement={
                      opportunity && opportunity.visibility === "Public" ? (
                        <Icon name="tick" size={11} color="#00998c" />
                      ) : null
                    }
                    onClick={() => onVisibilityChange("Public")}
                  />
                  <MenuItem
                    className={
                      opportunity && opportunity.visibility === "Private"
                        ? styles.selectedMenuItem
                        : null
                    }
                    text="Private"
                    labelElement={
                      opportunity && opportunity.visibility === "Private" ? (
                        <Icon name="tick" size={11} color="#00998c" />
                      ) : null
                    }
                    onClick={() => onVisibilityChange("Private")}
                  />
                </MenuItem>
                <MenuItem
                  className={classNames("narrow", "bold", styles.discontinue)}
                  text="Discontinue"
                  onClick={onDiscontinue}
                />
              </Menu>
              )}
            </Popover>
          </ButtonGroup>
        </ToolbarGroup>
      </div>
      <div className={styles.breadcrumbs}>
        <Breadcrumbs
          items={BREADCRUMBS}
          currentBreadcrumbRenderer={({ text, ...restProps }) => (
            <Breadcrumb className={styles.breadcrumb} {...restProps}>
              {text}
            </Breadcrumb>
          )}
        />
      </div>
    </div>
  );
}

export default OpportunityDetailsHeader;
